/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, identity, none, RestSettings, sortByIgnoreCase } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import { PrinterDto, PrintersDto } from './printer.dto';

@Injectable()
export class PrinterRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  create(printer: PrinterDto): Observable<PrinterDto> {
    return this.httpPost(`${this.bp}/system-variables/printers`, printer, identity());
  }

  update(printer: PrinterDto): Observable<PrinterDto> {
    return this.httpPut(`${this.bp}/system-variables/printers/${printer.cloudPrinterId}`, printer, identity());
  }

  findAll(): Observable<PrintersDto> {
    return this.httpGet(`${this.bp}/system-variables/printers`, identity());
  }

  changePrintType(isCloud: boolean): Observable<void> {
    return this.httpPut(`${this.bp}/system-variables/print-method/${isCloud}`, void 0, none());
  }

  findAllForFinder(): Observable<PrinterDto[]> {
    return this.httpGet(`${this.bp}/system-variables/printers/finder`, arrayOf(identity())).pipe(
      map$(sortByIgnoreCase<PrinterDto>('cloudPrinterName')));
  }

  remove(printerId: ID): Observable<void> {
    return this.httpDelete(`${this.bp}/system-variables/printers/${printerId}`, void 0, none());
  }
}
